import { Box, Center, Spinner } from '@chakra-ui/react';
import { DITable } from 'plugins/DITable';
import TablePagination from 'plugins/DITable/Pagination';
import PDPToolbar from './Toolbar';
import PDPModal from './Modal/AddEditModal';
import useProductDetails from './useProductDetails';
import PDPDeleteModal from './Modal/DeleteModal';

interface IProductDetailsTabProps {
    readonly: boolean;
    limitedAccess?: boolean;
}

const ProductdetailsTab = ({ readonly, limitedAccess }: IProductDetailsTabProps) => {
    const {
        isPDPLoading,
        isPDPFetching,
        dataToSubmit,
        setDataToSubmit,
        table,
        handleOpenModal,
        modalType,
        dateInWeeks,
        setDateInWeeks,
        isModalOpen,
        setIsModalOpen,
        selectedPDPs,
        retailer,
        setRetailer,
        lang,
        pdpData,
        setLang,
        handleDelete,
        deletePDPs,
        isDeleteOpen,
        handleCloseDelete,
        isDeleteLoading,
        handleDeletePDPs,
        isDeleteMultiple,
        deleteInitialRef,
        isExportLoading,
        todaysDate,
        isExportFetching,
        handleExportPDPs,
    } = useProductDetails({ readonly, limitedAccess });

    return (
        <Box mt="16px">
            <PDPToolbar
                {...{
                    table,
                    isPDPLoading,
                    handleOpenModal,
                    setDataToSubmit,
                    selectedPDPs,
                    handleDelete,
                    handleExportPDPs,
                    isExportLoading,
                    isExportFetching,
                    retailer,
                    pdpData,
                    setRetailer,
                    todaysDate,
                    lang,
                    setLang,
                    dateInWeeks,
                    setDateInWeeks,
                    readonly,
                    limitedAccess,
                }}
            />
            {isPDPFetching ? (
                <Center w="100%" h="200px" bg="white" border="1px solid" borderColor="gray.100">
                    <Spinner />
                </Center>
            ) : (
                <>
                    <DITable table={table} isPagination isHeaderFixed />
                    <TablePagination table={table} />
                    <PDPModal
                        {...{
                            dataToSubmit,
                            setDataToSubmit,
                            lang,
                            retailer,
                            deletePDPs,
                            todaysDate,
                            isDeleteLoading,
                            isModalOpen,
                            setIsModalOpen,
                            modalType,
                            readonly,
                            limitedAccess,
                            dateInWeeks,

                        }}
                    />
                    <PDPDeleteModal
                        {...{
                            isDeleteOpen,
                            handleCloseDelete,
                            isDeleteLoading,
                            handleDeletePDPs,
                            isDeleteMultiple,
                            deleteInitialRef,
                        }}
                    />
                </>
            )}
        </Box>
    );
};

export default ProductdetailsTab;
